import React, { useState, useEffect } from 'react';
import { CButton } from '@coreui/react';
import './CookieBanner.scss';
import { Trans, useTranslation } from 'react-i18next';

const PERSONAL_DATA_POLICY_URL = 'https://docs.medita.site/medita-docs/yd/politika-v-otnoshenii-obrabotki-personalnykh-dann?view=pvf1b';

const CookieBanner = () => {
	const [isVisible, setIsVisible] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		// Проверяем, было ли уже дано согласие
		const cookieConsent = localStorage.getItem('cookieConsent');
		if (!cookieConsent) {
			setIsVisible(true);
		}
	}, []);

	const handleAccept = () => {
		// Сохраняем согласие в localStorage
		localStorage.setItem('cookieConsent', 'accepted');
		setIsVisible(false);
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="cookie-banner">
			<div className="cookie-banner__content">
				<p className="cookie-banner__text">
					<Trans
						i18nKey="cookie.text"
						components={{
							policy: <a rel="noreferrer" target="_blank" href={PERSONAL_DATA_POLICY_URL}>policy</a>,
						}}
					/>
				</p>
				<CButton 
					color="primary" 
					onClick={handleAccept}
					className="cookie-banner__button"
				>
					{t('common.accept')}
				</CButton>
			</div>
		</div>
	);
};

export default CookieBanner;
